// Service for managing the message notification date across the application
const MESSAGE_DATE_KEY = 'messageNotificationDate'

class MessageDateService {
  // Get the stored message date, defaults to today if not set
  getMessageDate(): string {
    const storedDate = localStorage.getItem(MESSAGE_DATE_KEY)
    if (storedDate) {
      return storedDate
    }
    // Return today's date in YYYY-MM-DD format
    return new Date().toLocaleString('sv').split(' ')[0]
  }

  // Set the message date
  setMessageDate(date: string): void {
    if (date) {
      localStorage.setItem(MESSAGE_DATE_KEY, date)
    }
  }

  // Clear the stored date
  clearMessageDate(): void {
    localStorage.removeItem(MESSAGE_DATE_KEY)
  }

  // Check if a date is stored
  hasStoredDate(): boolean {
    return !!localStorage.getItem(MESSAGE_DATE_KEY)
  }
}

export const messageDateService = new MessageDateService()